import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers, RequestOptions } from '@angular/http';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-attachment-requests',
  templateUrl: 'attachment-requests.html',
  providers:[EnvDataService]
})
export class AttachmentRequestsPage {

  documentAttachmentRequestsForm: FormGroup;
  public form_name: any;
  public getRole: any;
  public header_title: any;
  public allDocuments: any;
  public userRole: any;
  public contactDetails: any;
  public contact_uid: any;
  public email:any;
  public uid: any;
  public selectedDocuments: any;
  public reference_broker: any;
  public requested_document_request_again: number;

  public validation_messages = {
    'attachment_requests': [
        { type: 'required', message: 'Select required documents.' }
    ]
  }

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    public db: AngularFirestore,
    private EnvDataService:EnvDataService
  ) {

    let thiss = this;
    //let email = window.localStorage.getItem("email");

    this.form_name = "eLINK Finance";
    this.header_title = "Attachment Requests";
    this.documentAttachmentRequestsForm = formBuilder.group({
      attachment_requests: ['', Validators.compose([Validators.required])],
      request_document_comment: ['']
    });
    this.allDocuments = [];
    this.contact_uid = this.navParams.get("contact_uid");
    this.reference_broker = this.navParams.get("reference_broker");
    
    this.attachment_documents().subscribe((data)=>{
      if(data.length > 0){
        Object.keys(data[0]).forEach(function(key) {
          thiss.allDocuments.push(data[0][key]);
        });
      }
    });
    this.getContactDetails().subscribe((data)=>{
      if(data.length > 0){
        this.contactDetails = data[0].firstname+' '+data[0].lastname;
        if(data[0].requested_documents == "" || data[0].requested_documents == null || data[0].requested_documents == undefined){}else{
          this.requested_document_request_again = 1;
        }
      }
    });    
    this.userRole = window.localStorage.getItem("userRole");

  }

  attachment_documents (){
    return this.db.collection<any>( "attachment_documents_name" ).valueChanges ();
  }

  getContactDetails (){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.contact_uid )).valueChanges ();
  }

  isFieldValid(field: string) {
    return !this.documentAttachmentRequestsForm.get(field).valid && this.documentAttachmentRequestsForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  public closeModal(){
    this.navCtrl.pop();
  }

  send_attachment_requests(){
    if(!this.documentAttachmentRequestsForm.valid){
      this.documentAttachmentRequestsForm.get('attachment_requests').markAsDirty();
      this.documentAttachmentRequestsForm.get('attachment_requests').markAsTouched();
    }else{
      this.loadingProvider.startLoading();
      let uid = window.localStorage.getItem("uid");
      if(uid != null){
        let attachment_requests = this.documentAttachmentRequestsForm.value.attachment_requests;
        let request_document_comment = this.documentAttachmentRequestsForm.value.request_document_comment;

        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });

        let postData = {
          "attachment_requests": attachment_requests,
          "request_document_comment": request_document_comment,
          "mail_attachment_requests": attachment_requests.join(', '),
          "contact_uid": this.contact_uid,
          "reference_broker": this.reference_broker,
        }
        console.log(postData);
        var url = this.EnvDataService.EnvData.sendbox_api+"/sendDocumentAttachmentRequest";
        this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          console.log(data);
          if(data['_body'] == 'success'){
            this.loadingProvider.stopLoading();  
            this.presentToast('Sent request successfully'); 
            this.navCtrl.pop();         
          }else{
            this.loadingProvider.stopLoading();
            this.presentToast('Something went wrong please try again later.');
          }
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToast(error.message);
        });
      }
    }
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ionViewDidLoad() {
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  slectMultipleDocument(event){
    if(event.length){
      this.selectedDocuments = event;
    }else{
      this.selectedDocuments = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/attachment-requests/attachment-requests.ts